import type { BodyTokens } from './types';

export const body: BodyTokens = {
  letterSpacings: {
    base: 'microCondensed',
    small: 'microCondensed',
    xSmall: null,
    xxSmall: null,
  },
};
